/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { observer } from 'mobx-react';
import advSearchState from 'Stores/advSearch';
import { advSearchFilterPopupState } from 'Stores/advSearchFIlterPopup';
import commonAppData from 'Stores/commonAppData';
import companySearchState from 'Stores/companySearch';
import Utils from 'Utils/utils';
import * as CONSTANTS from 'Utils/constants';
// import LoadingWrapper from 'Components/common/loadingWrapper';
import CheckBox from 'Components/common/CheckBox';
import noSuggestionFound from 'Assets/png/noSuggestionFound.png';
import { ReactComponent as DropDownIcon } from 'Assets/svg/down-arrow-icon.svg';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-icon.svg';
import ToggleType from 'Components/common/Toggle';
import Dropdown from 'Components/common/dropdown';
import Button from 'Components/common/Button';
// import userDetail from 'Stores/userDetail';

let cancelIndustryCall = null;
const IndustrySectorSearch = observer(props => {
  const {
    placeholder = 'Industry',
    searchBoxId = 'industrySectorBox',
    filterInPage = false,
    currentTab = 'contact',
    parentSelectorId = '',
    enableSectors = true,
  } = props;
  const suggestionKey = 'industrySectorsV2';

  let currentSelectedState;
  if (currentTab === 'contact')
    if (filterInPage) {
      currentSelectedState = advSearchState;
    } else {
      currentSelectedState = advSearchFilterPopupState;
    }
  else currentSelectedState = companySearchState;

  const [showSuggestion, setShowSuggestion] = React.useState(false);
  const [industrySectorsData, setIndustrySectorsData] = React.useState({});
  const [suggestionLoading, setSuggestionLoading] = React.useState(false);
  const [isExcludeEnabled, setIsExcludeEnabled] = React.useState(false);

  const {
    industries: industryListSuggestions = [],
    isAllIndustry,
  } = industrySectorsData;

  const [noMatchFound, setNoMatchFound] = React.useState(false);
  const [industryFilterText, setIndustryFilterText] = React.useState('');

  const generateAllIndustryValue = (
    data,
    isSelected = false,
    isSectorOpened = false,
    retainSectorOpenState = false,
  ) => {
    const newList = data.map(item => {
      const sectorsValue = item.sectors ? item.sectors : [];
      const formttedSectorObj = [];
      const { industry } = item;
      const { highlightText = '', originalText = '' } = industry || item;
      const { hasSectors, showField } = item;
      const newObj = {
        selected: isSelected,
        sectorOpen: isSectorOpened,
        highlightText,
        originalText,
        name: originalText,
        showField,
        hasSectors,
      };

      if (sectorsValue.length)
        // eslint-disable-next-line array-callback-return
        sectorsValue.map(sector => {
          const { originalText: sectorOriginalText } = sector;
          const newSectorObj = {
            ...sector,
            selected: isSelected,
            name: sectorOriginalText,
          };
          formttedSectorObj.push(newSectorObj);
        });
      newObj.sectors = formttedSectorObj;
      if (
        retainSectorOpenState &&
        industryListSuggestions &&
        industryListSuggestions.length
      )
        industryListSuggestions.map(industryItemVal => {
          const { name, sectorOpen } = industryItemVal;
          if (newObj.name === name) newObj.sectorOpen = sectorOpen;
        });
      return newObj;
    });

    return newList;
  };

  const constructPayloadV2 = (payDataOrg, setNewData) => {
    const industrySectorsV2 = [];
    const excludeIndustrySectorsV2 = [];
    const payData = Utils.copyObjectWithoutReference(payDataOrg);
    if (payData)
      if (payData.isAllIndustry) {
        payData.industries.forEach(data => {
          industrySectorsV2.push({
            id: data.originalText,
            industryOrSectorText: data.originalText,
            name: data.originalText,
            orgName: data.originalText,
            pName: data.originalText,
            parentIndustry: null,
          });
        });
      } else {
        payData.industries.forEach(data => {
          const excludedSectors = data.sectors.filter(
            prop => prop.excluded ?? false,
          );
          if (data.excluded ?? false)
            excludeIndustrySectorsV2.push({
              id: data.originalText,
              industryOrSectorText: data.originalText,
              name: data.originalText,
              orgName: data.originalText,
              pName: data.originalText,
              parentIndustry: null,
            });
          else if (data.selected)
            industrySectorsV2.push({
              id: data.originalText,
              industryOrSectorText: data.originalText,
              name: data.originalText,
              orgName: data.originalText,
              pName: data.originalText,
              parentIndustry: null,
            });
          if (data.sectors && data.sectors.length > 0) {
            const selectedSectors = data.sectors.filter(prop => prop.selected);
            if (selectedSectors.length > 0 && !data.selected)
              selectedSectors.forEach(prop => {
                industrySectorsV2.push({
                  id: prop.originalText,
                  industryOrSectorText: prop.originalText,
                  name: prop.originalText,
                  orgName: prop.originalText,
                  pName: prop.originalText,
                  parentIndustry: data.originalText,
                });
              });
            if (excludedSectors.length > 0 && !data.excluded)
              excludedSectors.forEach(prop => {
                excludeIndustrySectorsV2.push({
                  id: prop.originalText,
                  industryOrSectorText: prop.originalText,
                  name: prop.originalText,
                  orgName: prop.originalText,
                  pName: prop.originalText,
                  parentIndustry: data.originalText,
                });
              });
          }
        });
      }
    if (setNewData !== undefined && setNewData) {
      const mxDataMap = {};
      if (currentTab === 'contact')
        if (filterInPage) mxDataMap.filterPlace = 'page';
        else mxDataMap.filterPlace = 'popup';
      else mxDataMap.filterPlace = 'page';

      mxDataMap.currentTab = currentTab;
      mxDataMap.filterKey = suggestionKey;
      mxDataMap.isIncluded = true;

      if (isExcludeEnabled) {
        mxDataMap.filterKey = 'excludeIndustrySectorsV2';
        mxDataMap.isIncluded = false;
        mxDataMap.filterValue = excludeIndustrySectorsV2.map(
          item1 => item1.name,
        );
      } else {
        mxDataMap.filterValue = industrySectorsV2.map(item1 => item1.name);
      }

      Utils.mixpanelTrack(
        CONSTANTS.MX_AS_EVENTS.LB_AS_INDUSTRY_SEARCH_PERFORMED,
        mxDataMap,
      );
      currentSelectedState.setAppliedFilters(
        'excludeIndustrySectorsV2',
        excludeIndustrySectorsV2,
        null,
        true,
        false,
      );
      currentSelectedState.setAppliedFilters(
        suggestionKey,
        industrySectorsV2,
        null,
        true,
        true,
      );
    }
  };

  const generateIndustryListDataV1 = (
    industryListApiData,
    makeApiCall = false,
    isSectorOpened = null,
    retainSectorOpenState = null,
  ) => {
    const { appliedFilterSectionData } = currentSelectedState;
    const { industrySectorsV2 = [], excludeIndustrySectorsV2 = [] } =
      appliedFilterSectionData || {};

    let tempDetailSearchObj = {};

    const appliedIsAllIndustry =
      industrySectorsV2.filter(data => data.parentIndustry === null)?.length ===
      industryListApiData.length;

    if (appliedIsAllIndustry) {
      // Set all industry selected
      const formattedList = generateAllIndustryValue(
        industryListApiData,
        true,
        isSectorOpened !== null ? isSectorOpened : false,
      );
      tempDetailSearchObj = {
        industries: formattedList,
        isAllIndustry: true,
      };
    } else if (
      industrySectorsV2.length > 0 ||
      excludeIndustrySectorsV2.length > 0
    ) {
      // Handle selected values
      const deReferencedIndustryListAPIData = Utils.copyObjectWithoutReference(
        industryListApiData,
      );

      const getFieldsFromIndustry = listData => {
        if (listData.industry) {
          const { originalText, highlightText } = listData.industry;
          return {
            originalText,
            highlightText,
          };
        }
        const { originalText, highlightText } = listData;
        return { originalText, highlightText };
      };

      const list = deReferencedIndustryListAPIData.map(listData => {
        const { showField, hasSectors, sectors } = listData;
        const { originalText, highlightText } = getFieldsFromIndustry(listData);

        const isIndustrySelected = industrySectorsV2.some(
          selectedData => selectedData.name === originalText,
        );
        const isIndustryExcluded = excludeIndustrySectorsV2.some(
          excludeIndustry => excludeIndustry.name === originalText,
        );

        return {
          highlightText,
          originalText,
          name: originalText,
          selected: isIndustrySelected && !isIndustryExcluded,
          showField,
          excluded: isIndustryExcluded,
          hasSectors,
          sectorOpen:
            isSectorOpened !== null
              ? isSectorOpened
              : industryListSuggestions.find(data => data.name === originalText)
                  ?.sectorOpen || false,
          sectors: sectors?.map(sector => {
            const isSectorSelected = industrySectorsV2.some(
              selectedData =>
                selectedData.name === sector.originalText &&
                selectedData.parentIndustry === originalText,
            );
            const isSectorExcluded = excludeIndustrySectorsV2.some(
              excludeSector =>
                excludeSector.name === sector.originalText &&
                excludeSector.parentIndustry === originalText,
            );
            return {
              highlightText: sector.highlightText,
              name: sector.originalText,
              originalText: sector.originalText,
              selected:
                (isIndustrySelected || isSectorSelected) && !isSectorExcluded,
              showField: sector.showField,
              excluded: isSectorExcluded || isIndustryExcluded,
            };
          }),
        };
      });

      tempDetailSearchObj = {
        industries: list,
        isAllIndustry: appliedIsAllIndustry,
      };
    } else if (industrySectorsV2.length === 0) {
      // Set all unselected
      const formattedList = generateAllIndustryValue(
        industryListApiData,
        false,
        isSectorOpened !== null ? isSectorOpened : false,
        retainSectorOpenState !== null ? retainSectorOpenState : false,
      );
      tempDetailSearchObj = {
        industries: formattedList,
        isAllIndustry: false,
      };
    }

    setIndustrySectorsData(tempDetailSearchObj);
    constructPayloadV2(tempDetailSearchObj, makeApiCall);
  };

  const generateListWithDisplayFields = (suggestionData = []) => {
    const industryFullData = Utils.copyObjectWithoutReference(
      commonAppData.industrySectorsFullData,
    );

    let formattedDisplayData = [];
    if (suggestionData.length)
      formattedDisplayData = industryFullData.map(industryItemData => {
        const { industry, sectors: fullSectorsData } = industryItemData;

        const newIndustryData = Utils.copyObjectWithoutReference(
          industryItemData,
        );

        newIndustryData.showField = false;
        newIndustryData.hasSectors = false;

        let suggestionIndustryData = null;
        suggestionData.map(item => {
          const { industry: suggestionIndustry } = item;
          if (industry.originalText === suggestionIndustry.originalText)
            suggestionIndustryData = item;
        });

        if (suggestionIndustryData !== null) {
          const {
            sectors: suggestionSectorsData = [],
            industry: suggestionIndustry,
          } = suggestionIndustryData;
          newIndustryData.industry = { ...industry, ...suggestionIndustry };
          newIndustryData.showField = true;

          if (suggestionSectorsData.length && enableSectors) {
            const newSectorsData = fullSectorsData.map(fullSectorItem => {
              const newSector = fullSectorItem;
              newSector.showField = false;
              suggestionSectorsData.map(suggestionSectorItem => {
                if (
                  fullSectorItem.originalText ===
                  suggestionSectorItem.originalText
                ) {
                  newSector.showField = true;
                  newSector.highlightText = suggestionSectorItem.highlightText;
                }
              });
              return newSector;
            });
            newIndustryData.sectors = newSectorsData;
            newIndustryData.hasSectors = true;
          }
        }
        return newIndustryData;
      });

    return formattedDisplayData;
  };

  const getIndustrySectorsSuggestion = async (
    queryString = '',
    cancelCallback = () => {},
  ) => {
    try {
      const response = await commonAppData.getIndustrySuggestions(
        queryString,
        cancelCallback,
      );

      if (response && response.data) {
        const newList = generateListWithDisplayFields(response.data);
        if (newList.length) generateIndustryListDataV1(newList, false, true);
        else setNoMatchFound(true);
        setSuggestionLoading(false);
      }
    } catch (error) {
      console.log('Industry auto complete error', error);
    }
  };

  const onIndustryInputSearchChange = e => {
    setNoMatchFound(false);
    if (e) {
      const inpVal = e.currentTarget.value.toLowerCase();
      setIndustryFilterText(inpVal);
      // Handle suggestions
      if (cancelIndustryCall !== null) {
        cancelIndustryCall('cancel');
        cancelIndustryCall = null;
      }
      const industryCancelCallback = value => {
        cancelIndustryCall = value;
      };
      setSuggestionLoading(true);
      if (inpVal.length > 0) {
        getIndustrySectorsSuggestion(inpVal, industryCancelCallback);
      } else {
        const newList = generateListWithDisplayFields(
          commonAppData.industrySectorsFullData,
        );
        setSuggestionLoading(false);
        if (newList.length) generateIndustryListDataV1(newList, false, false);
      }
      const selector = `${
        parentSelectorId !== '' ? `#${parentSelectorId}` : ''
      } .industry-dropdown-list-container .drop-down`;

      // eslint-disable-next-line no-undef
      const element = document.querySelector(selector);
      if (element !== null) element.scrollTo(0, 0);
    }
  };

  const focusInputBox = () => {
    const selector = `${
      parentSelectorId !== '' ? `#${parentSelectorId}` : ''
    } #${searchBoxId}`;
    // eslint-disable-next-line no-undef
    const element = document.querySelector(selector);
    setTimeout(() => {
      if (element !== undefined && element !== null) element.focus();
    }, 50);
  };

  const closeSuggestion = () => {
    // Set to default
    if (industryFilterText !== '') {
      setIndustryFilterText('');
      const newList = generateListWithDisplayFields(
        commonAppData.industrySectorsFullData,
      );
      setNoMatchFound(false);
      setSuggestionLoading(false);
      if (newList.length) generateIndustryListDataV1(newList, false, false);
    }
  };

  React.useEffect(() => {
    const newList = generateListWithDisplayFields(
      Utils.copyObjectWithoutReference(commonAppData.industrySectorsFullData),
    );

    generateIndustryListDataV1(newList);
  }, [commonAppData.industrySectorsFullData]);

  React.useEffect(() => {
    const { appliedFilterSectionData } = currentSelectedState;
    const { industrySectorsV2 = null, excludeIndustrySectorsV2 = null } =
      appliedFilterSectionData || {};
    if (
      industrySectorsV2 !== null &&
      excludeIndustrySectorsV2 !== null &&
      industryListSuggestions.length
    ) {
      generateIndustryListDataV1(industryListSuggestions, false);
    } else {
      const newList = generateListWithDisplayFields(
        Utils.copyObjectWithoutReference(commonAppData.industrySectorsFullData),
      );
      generateIndustryListDataV1(newList, false, null, true);
    }
  }, [
    currentSelectedState.appliedFilterSectionData.industrySectorsV2,
    currentSelectedState.appliedFilterSectionData.excludeIndustrySectorsV2,
  ]);

  React.useEffect(() => {
    focusInputBox();
  }, [industryFilterText]);

  const NoMatchFoundComponent = () => {
    return (
      <div className="no-match-found">
        <img src={noSuggestionFound} alt="No suggestion found" />
        No results found
      </div>
    );
  };
  const checkAllIndustrySelected = newState => {
    const { industries } = newState;
    let allIndustrySelected = true;
    let newArr1;
    if (industries)
      newArr1 = industries.map(value => {
        let allSectorSelected = true;
        const item = value;
        if (item.sectors !== 'undefined' && item.sectors.length) {
          item.sectors.map((sector, key) => {
            if (!sector.selected) allSectorSelected = false;
          });
          if (allSectorSelected) {
            item.selected = true;
          } else if (!allSectorSelected || !item.selected) {
            item.selected = false;
            allIndustrySelected = false;
          }
        } else if (!item.selected) {
          allIndustrySelected = item.selected;
        }
        return item;
      });
    const tempDetailSearchObj = {
      industries: newArr1,
      isAllIndustry: allIndustrySelected,
    };

    setIndustrySectorsData(tempDetailSearchObj);
  };

  const addSelectedIndustryItem = (e, selectedVal) => {
    if (e !== null && e !== undefined) e.stopPropagation();
    let formattedList;
    let tempDetailSearchObj = {};
    if (selectedVal === 'all') {
      formattedList = generateAllIndustryValue(
        industryListSuggestions,
        !isAllIndustry,
        true,
        true,
      );
      tempDetailSearchObj = {
        industries: formattedList,
        isAllIndustry: !isAllIndustry,
      };
    } else {
      let tempAllIndustrySelected = isAllIndustry;
      formattedList = industryListSuggestions.map(item => {
        const industryItem = item;
        const { name, selected, sectors } = industryItem;
        if (name === selectedVal) {
          industryItem.excluded = false;
          if (selected) {
            industryItem.selected = false;
            const sectorArr = sectors.map((val, key) => {
              // eslint-disable-next-line no-param-reassign
              val.selected = false;
              tempAllIndustrySelected = false;
              // eslint-disable-next-line no-param-reassign
              val.excluded = false;
              return val;
            });
            industryItem.sectors = sectorArr;
          } else {
            industryItem.selected = true;
            const sectorArr = sectors.map((val, key) => {
              // eslint-disable-next-line no-param-reassign
              val.selected = true;
              // eslint-disable-next-line no-param-reassign
              val.excluded = false;
              return val;
            });
            industryItem.sectors = sectorArr;
          }
        }
        return industryItem;
      });
      tempDetailSearchObj = {
        industries: formattedList,
        isAllIndustry: tempAllIndustrySelected,
      };
    }
    // eslint-disable-next-line consistent-return
    checkAllIndustrySelected(tempDetailSearchObj);
    focusInputBox();
  };

  const addExcludedIndustryItem = ({
    sectorOriginalText = null,
    industryOriginalText,
  }) => {
    const isFromSector = sectorOriginalText !== null;
    const modifiedDataIndex = industryListSuggestions.findIndex(
      data => data.name === industryOriginalText,
    );
    let modifiedData = Utils.copyObjectWithoutReference(
      industryListSuggestions,
    );
    if (modifiedDataIndex !== -1) {
      let duplicatedData = modifiedData[modifiedDataIndex];
      const { sectors = [], selected } = duplicatedData;

      if (isFromSector) {
        // for sector change
        const modifiedSectors = sectors?.map(sector => {
          const { excluded: sectorExcluded = false } = sector;
          return {
            ...sector,
            excluded:
              sector.name === sectorOriginalText
                ? !sectorExcluded
                : sectorExcluded,
            selected:
              sector.name === sectorOriginalText ? false : sector.selected,
          };
        });
        duplicatedData.sectors = modifiedSectors;
        duplicatedData = {
          ...duplicatedData,
          selected: !modifiedSectors.every(
            sectorData => sectorData.selected || sectorData.excluded,
          )
            ? false
            : selected,
          excluded: modifiedSectors.every(sectorData => sectorData.excluded),
        };
      } else {
        // from industry change
        const newExcludedValue = !duplicatedData.excluded;
        const modifiedSectors = sectors?.map(sector => {
          return {
            ...sector,
            excluded: newExcludedValue,
            selected: false,
          };
        });
        duplicatedData = {
          ...duplicatedData,
          sectors: modifiedSectors,
          selected: false,
          excluded: newExcludedValue,
        };
      }
      modifiedData = modifiedData.map((data, index) => {
        if (index === modifiedDataIndex) return duplicatedData;
        return data;
      });
    }
    setIndustrySectorsData({ industries: modifiedData, isAllIndustry: false });
    focusInputBox();
    // console.log(industryListSuggestions);
  };

  const addSelectedSectorItem = (e, selectedVal, selectedParentVal) => {
    if (e !== null && e !== undefined) e.stopPropagation();
    let tempAllSelected = isAllIndustry;
    const newArr = industryListSuggestions.map(item => {
      const industryItem = item;
      const { name, sectors } = industryItem;
      if (name === selectedParentVal) {
        const formattedSectors = sectors.map((value, key) => {
          const sectorItem = value;
          const { name: sectorName, selected: sectorSelected } = sectorItem;
          if (sectorName === selectedVal) {
            sectorItem.excluded = false;
            if (sectorSelected) {
              sectorItem.selected = false;
              industryItem.selected = false;
              tempAllSelected = false;
            } else {
              sectorItem.selected = true;
            }
          }
          return sectorItem;
        });
        industryItem.sectors = formattedSectors;
      }
      return industryItem;
    });
    const tempDetailSearchObj = {
      industries: newArr,
      isAllIndustry: tempAllSelected,
    };
    checkAllIndustrySelected(tempDetailSearchObj);
    focusInputBox();
  };

  const arrowAction = (e, selectedVal, hasSectors) => {
    if (hasSectors) {
      if (e !== null && e !== undefined) e.stopPropagation();
      const tempAllSelected = isAllIndustry;
      const newArr = industryListSuggestions.map(i => {
        const item = i;
        if (item.name === selectedVal)
          if (item.sectorOpen) item.sectorOpen = false;
          else item.sectorOpen = true;

        return item;
      });

      const tempDetailSearchObj = {
        industries: newArr,
        isAllIndustry: tempAllSelected,
      };
      setIndustrySectorsData(tempDetailSearchObj);
    }
    focusInputBox();
  };

  const renderIndustrySuggestion = () => {
    return (
      <div className="industry-dropdown-list-container">
        {industryListSuggestions && industryListSuggestions.length > 0 ? (
          <div className="drop-down">
            <div
              className={`all-container ${
                isAllIndustry ? ' all-selected  ' : ''
              }`}
            >
              {industryFilterText === '' && (
                <div
                  className={`naming-cont select-all-checkbox${
                    isExcludeEnabled ? ' disable' : ''
                  }`}
                  onClick={e => {
                    if (!isExcludeEnabled) addSelectedIndustryItem(e, 'all');
                  }}
                  data-name="all"
                >
                  <CheckBox dymamicClass={isAllIndustry ? ' selected' : ''} />
                  <span className="detail-search-name" title="ALL">
                    Select all
                  </span>
                </div>
              )}
              {industryListSuggestions.map((item, key) => {
                const {
                  selected: industrySelected,
                  highlightText: industryHighlightText,
                  originalText: industryOriginalText,
                  sectorOpen,
                  sectors,
                  excluded: excludedIndustry = false,
                  showField: showIndustryField,
                  hasSectors,
                } = item;
                return showIndustryField ? (
                  <div
                    key={`detailsearch${key}`}
                    className={`suggestion-item${
                      industrySelected ? ' selected' : ''
                    }`}
                    data-name={industryOriginalText}
                  >
                    <div
                      className="naming-cont"
                      onClick={e => {
                        e.stopPropagation();
                        if (isExcludeEnabled)
                          addExcludedIndustryItem({ industryOriginalText });
                        else addSelectedIndustryItem(e, industryOriginalText);
                      }}
                      data-name={industryOriginalText}
                    >
                      <DropDownIcon
                        className={`collapse-dropdown-icon ${
                          sectorOpen ? '' : ' dropdown-closed'
                        } ${hasSectors ? '' : ' hide-dropdown'}`}
                        width={10}
                        height={10}
                        data-name={industryOriginalText}
                        onClick={e =>
                          arrowAction(e, industryOriginalText, hasSectors)
                        }
                      />
                      {excludedIndustry ? (
                        <span className="material-icons exclude-icon">
                          indeterminate_check_box
                        </span>
                      ) : (
                        <CheckBox
                          dymamicClass={industrySelected ? ' selected' : ''}
                        />
                      )}
                      {/* <span
                        className="detail-search-name"
                        title={industryOriginalText}
                      >
                        {industryHighlightText}
                      </span> */}
                      <span
                        className="detail-search-name"
                        title={industryOriginalText}
                        dangerouslySetInnerHTML={{
                          __html: industryHighlightText || '',
                        }}
                      />
                    </div>
                    {hasSectors && sectors && sectors.length > 0 ? (
                      <div
                        className={`inner-suggestion-cont ${
                          sectorOpen ? ' sectorSelected' : ''
                        }`}
                      >
                        {sectors.map((sector, index) => {
                          const {
                            selected: sectorSelected,
                            highlightText: sectorHighlightText,
                            originalText: sectorOriginalText,
                            showField: showSectorField,
                            excluded: excludedSector = false,
                          } = sector;
                          return showSectorField ? (
                            <div
                              className={`inner-suugestion-item${
                                sectorSelected ? ' selected' : ''
                              }${
                                excludedIndustry && !isExcludeEnabled
                                  ? ' disable'
                                  : ''
                              }`}
                              data-name={sectorOriginalText}
                              data-parent-name={industryOriginalText}
                              onClick={e => {
                                e.stopPropagation();
                                if (
                                  !excludedIndustry ||
                                  (excludedIndustry && isExcludeEnabled)
                                )
                                  if (isExcludeEnabled)
                                    addExcludedIndustryItem({
                                      sectorOriginalText,
                                      industryOriginalText,
                                    });
                                  else
                                    addSelectedSectorItem(
                                      e,
                                      sectorOriginalText,
                                      industryOriginalText,
                                    );
                              }}
                              key={`sector${key}-${index}`}
                            >
                              {excludedSector || excludedIndustry ? (
                                <span className="material-icons exclude-icon">
                                  indeterminate_check_box
                                </span>
                              ) : (
                                <CheckBox
                                  dymamicClass={
                                    sectorSelected ? ' selected' : ''
                                  }
                                />
                              )}
                              {/* <span
                                className="detail-search-name"
                                title={sectorOriginalText}
                              >
                                {sectorHighlightText}
                              </span> */}
                              <span
                                className="detail-search-name"
                                title={sectorOriginalText}
                                dangerouslySetInnerHTML={{
                                  __html: sectorHighlightText || '',
                                }}
                              />
                            </div>
                          ) : (
                            ''
                          );
                        })}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                ) : (
                  ''
                );
              })}
            </div>
          </div>
        ) : (
          <div className="industry-loading-wrapper">
            {/* {isLoading ? (
              <LoadingWrapper show={isLoading} position="absolute" />
            ) : ( */}
            <div className="not-found">Industries not found</div>
            {/* )} */}
          </div>
        )}
      </div>
    );
  };

  const { appliedFilterSectionData } = currentSelectedState;
  const { industrySectorsV2 = [], excludeIndustrySectorsV2 = [] } =
    appliedFilterSectionData || {};

  return (
    <div
      className={`dropdown-section industry-dropdown ${
        showSuggestion ? 'dropdown-focused' : ''
      }`}
      id={parentSelectorId}
    >
      <Dropdown
        onOpenDropdown={focusInputBox}
        onCloseDropdown={closeSuggestion}
        className="suggestion-list"
        toggleElement={
          <div className="dropdown-box" onClick={focusInputBox}>
            {placeholder}
            {(!isExcludeEnabled && industrySectorsV2.length > 0) ||
            (isExcludeEnabled && excludeIndustrySectorsV2.length > 0) ? (
              <div className="dropdown-icon selected-count">
                <span>
                  {isExcludeEnabled
                    ? excludeIndustrySectorsV2.length
                    : industrySectorsV2.length}
                </span>
              </div>
            ) : (
              !showSuggestion && (
                <DropDownIcon
                  className="dropdown-icon plus-icon"
                  width={14}
                  height={14}
                />
              )
            )}
          </div>
        }
      >
        <div className="pop-input-box-wrap" onClick={e => e.stopPropagation()}>
          <div className="pop-input-box">
            <input
              type="text"
              id={searchBoxId}
              className="pop-search-box"
              value={industryFilterText}
              onChange={onIndustryInputSearchChange}
              placeholder={`Filter ${placeholder}`}
              autoComplete="new-password"
            />
            {suggestionLoading && <i className="fa fa-spinner fa-spin" />}
          </div>
        </div>

        {noMatchFound || industryListSuggestions.length === 0 ? (
          <div
            className="suggestion-list-wrap"
            onClick={e => e.stopPropagation()}
          >
            <NoMatchFoundComponent />
          </div>
        ) : (
          industryListSuggestions.length > 0 && renderIndustrySuggestion()
        )}
        <Button
          btnText="Apply"
          className="apply-btn"
          disabled={false}
          click={() => {
            constructPayloadV2(industrySectorsData, true);
          }}
        />
      </Dropdown>
      <div className="include-exclude-toggle icon-text-wrapper">
        <ToggleType
          firstText="Include"
          toggle={isExcludeEnabled}
          offer={false}
          cbk={() => setIsExcludeEnabled(!isExcludeEnabled)}
          lastText="Exclude"
          showSharpPoint
        />
        <div className="icon-container">
          <InfoIcon width={18} height={18} className="title-info-icon" />
          <div className="tooltip-wrap">
            <span className="tooltip">
              Toggle here to include or omit industries.
            </span>
            <span className="sharp-point" />
          </div>
        </div>
        <span className="ripple-effect" />
      </div>
    </div>
  );
});

export { IndustrySectorSearch };
export default IndustrySectorSearch;
